import axios from "axios"
import { isBrowser } from "./util"
import { ENDPOINTS } from "./endpoints"

export const setEmailPreferences = (subscriberKey, values) => {
    values['subscriber_key'] = subscriberKey;
    return new Promise(function(resolve, reject) {
        if(!isBrowser()){
            reject("Do not do this from Node!")
        }else{
            axios.post(
                ENDPOINTS.profileSet,
                values,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            ).then((result) => {
                resolve(result)
            }).catch((err)=>{
                reject(err)
            })
        }
    })
}